// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon-module__icon___1IxTO","click":"Icon-module__click___3tcJG","disabled":"Icon-module__disabled___2kTkb","active":"Icon-module__active___1Xw8J"};